import _ from 'underscore';
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useFormService, FORM_STATES } from '@bingads-webui-react/form';

import { AdAssetsStepView } from './ad-assets-step-view';
import { useImageListStateHandler } from './use-image-list-state-handler';

export const AdAssetsStep = ({
  data,
  error,
  onDataChange,
  hideStepInfo,
  bypassSettingGlobalLegacyI18n,
}) => {
  const i18n = useContext(I18nContext);

  const { state } = useFormService();
  const { context: { saveFailed } } = state;
  const isSaving = state.matches(FORM_STATES.SAVING);

  const [previewTextAssets, setPreviewTextAssets] = useState({
    Headlines: 'Headline0',
    LongHeadlines: 'LongHeadline0',
    Descriptions: 'Description0',
  });

  const {
    imageListState,
    onImageListUpdated,
    onImageSelected,
    onClearList,
    onSetCropImageObj,
    onSetEditingPlacementType,
  } = useImageListStateHandler(i18n, data, onDataChange);

  return (
    <AdAssetsStepView
      isLoading={_.isEmpty(data) || imageListState.isLoading}
      isSaving={isSaving}
      saveFailed={saveFailed}
      data={data}
      error={error}
      onDataChange={onDataChange}
      imageListState={imageListState}
      onImageListUpdated={onImageListUpdated}
      onImageSelected={onImageSelected}
      onClearList={onClearList}
      onSetCropImageObj={onSetCropImageObj}
      onSetEditingPlacementType={onSetEditingPlacementType}
      hideStepInfo={hideStepInfo}
      bypassSettingGlobalLegacyI18n={!!bypassSettingGlobalLegacyI18n}
      previewTextAssets={previewTextAssets}
      setPreviewTextAssets={setPreviewTextAssets}
    />
  );
};

AdAssetsStep.propTypes = {
  data: PropTypes.shape({
    assetGroupData: PropTypes.shape({}),
  }),
  error: PropTypes.shape(),
  onDataChange: PropTypes.func.isRequired,
  hideStepInfo: PropTypes.bool,
  bypassSettingGlobalLegacyI18n: PropTypes.bool,
};

AdAssetsStep.defaultProps = {
  data: undefined,
  error: undefined,
  hideStepInfo: false,
  bypassSettingGlobalLegacyI18n: false,
};
